export { default } from './SliderImatges';